import React, { useEffect } from 'react';

import { FullScreenLoader } from 'components/FullScreenLoader';
import { useUserContext } from 'contexts/UserContext';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';
import { ShopifyService } from 'services/shopify-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { UserAccess } from 'shared/interfaces/User';
import { extractRedirectPathFromQueryParams } from 'shared/utils/navigation';

export function PostLoginRouterPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user] = useUserContext();

  useEffect(() => {
    // We wait until the user context is loaded
    if (!user._id) return;

    const queryParams = queryString.parse(location.search);
    const queryStringParams = queryString.stringify(queryParams);
    const redirectPath = extractRedirectPathFromQueryParams(queryParams);

    if (ShopifyService.isShopifyStoreDataInLocalStorage()) {
      return navigate(ROUTE_LINKS.shopifyAuthHandler);
    }

    if (!user.hasCompletedOnboarding && user.role === UserAccess.SUPER_ADMIN) {
      return navigate(`${ROUTE_LINKS.onboarding}${queryStringParams ? `?${queryStringParams}` : ''}`);
    }

    if (redirectPath) {
      return navigate(redirectPath);
    }

    return navigate(ROUTE_LINKS.smartAssistants);
  }, [user, location]);

  return <FullScreenLoader />;
}
